export const ListView = () => {
  return (
    <svg
      width="127px"
      height="102px"
      viewBox="0 0 127 102"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <title>Group 25</title>
      <g id="QSR" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="Group-25" fill="#464646" fillRule="nonzero">
          <path
            d="M20.25,0 L6.75,0 C3.02207794,0 0,3.02207794 0,6.75 L0,20.25 C0,23.9779221 3.02207794,27 6.75,27 L20.25,27 C23.9779221,27 27,23.9779221 27,20.25 L27,6.75 C27,3.02207794 23.9779221,0 20.25,0 Z M7,20 L7,7 L20,7 L20,20 L7,20 Z"
            id="Rectangle"
          ></path>
          <path
            d="M20.25,37 L6.75,37 C3.02207794,37 0,40.0220779 0,43.75 L0,57.25 C0,60.9779221 3.02207794,64 6.75,64 L20.25,64 C23.9779221,64 27,60.9779221 27,57.25 L27,43.75 C27,40.0220779 23.9779221,37 20.25,37 Z M7,57 L7,44 L20,44 L20,57 L7,57 Z"
            id="Rectangle-Copy-6"
          ></path>
          <path
            d="M20.25,75 L6.75,75 C3.02207794,75 0,78.0220779 0,81.75 L0,95.25 C0,98.9779221 3.02207794,102 6.75,102 L20.25,102 C23.9779221,102 27,98.9779221 27,95.25 L27,81.75 C27,78.0220779 23.9779221,75 20.25,75 Z M7,95 L7,82 L20,82 L20,95 L7,95 Z"
            id="Rectangle-Copy-7"
          ></path>
          <polygon id="Line-5" points="127 10 127 17 36 17 36 10"></polygon>
          <polygon
            id="Line-5-Copy"
            points="127 47 127 54 36 54 36 47"
          ></polygon>
          <polygon
            id="Line-5-Copy-2"
            points="127 85 127 92 36 92 36 85"
          ></polygon>
        </g>
      </g>
    </svg>
  );
};
